import styled, { css } from "styled-components"
import { parseUIPercents, parseUIPercentsMobile } from "../../utils"
export const LandingWrapper = styled.div`
  position: relative;
  width: 100vw;
  height: 100vh;
  background-color: #001c31;
  color: #ffe8c0;
  a {
    color: #ffe8c0;
    text-decoration: none; /* no underline */
  }
`
export const HelloWrapper = styled.div`
  position: absolute;
  top: ${parseUIPercents(216)};
  left: ${parseUIPercents(240)};
  font-size: ${parseUIPercents(36)};
  @media (max-width: 768px) {
    top: ${parseUIPercentsMobile(248)};
    left: 50%;
    transform: translateX(-50%);
    font-size: ${parseUIPercentsMobile(36)};
  }
`
export const KidaWrapper = styled.div`
  position: absolute;
  top: ${parseUIPercents(268)};
  left: ${parseUIPercents(240)};
  font-size: ${parseUIPercents(36)};
  @media (max-width: 768px) {
    top: ${parseUIPercentsMobile(300)};
    left: 50%;
    transform: translateX(-50%);
    font-size: ${parseUIPercentsMobile(36)};
  }
`
export const WorksWrapper = styled.div`
  position: absolute;
  top: ${parseUIPercents(444)};
  left: ${parseUIPercents(240)};
  font-size: ${parseUIPercents(16)};
  cursor: pointer;
  @media (max-width: 768px) {
    top: ${parseUIPercentsMobile(476)};
    left: 50%;
    transform: translateX(-50%);
    font-size: ${parseUIPercentsMobile(16)};
  }
`
export const PortfolioWrapper = styled.div`
  position: absolute;
  top: ${parseUIPercents(490)};
  left: ${parseUIPercents(240)};
  font-size: ${parseUIPercents(16)};
  cursor: pointer;
  @media (max-width: 768px) {
    top: ${parseUIPercentsMobile(522)};
    left: 50%;
    transform: translateX(-50%);
    font-size: ${parseUIPercentsMobile(16)};
  }
`

export const ContactWrapper = styled.div`
  position: absolute;
  top: ${parseUIPercents(536)};
  left: ${parseUIPercents(240)};
  font-size: ${parseUIPercents(16)};
  cursor: pointer;
  @media (max-width: 768px) {
    top: ${parseUIPercentsMobile(568)};
    left: 50%;
    transform: translateX(-50%);
    font-size: ${parseUIPercentsMobile(16)};
  }
`

const linkShared = css`
  width: ${parseUIPercents(24)};
  position: absolute;
  top: ${parseUIPercents(592)};
  cursor: pointer;
  @media (max-width: 768px) {
    width: ${parseUIPercentsMobile(24)};
    top: ${parseUIPercentsMobile(627)};
  }
`

export const DribbleLink = styled.div`
  ${linkShared};
  left: ${parseUIPercents(240)};
  @media (max-width: 768px) {
    left: ${parseUIPercentsMobile(107)};
  }
`
export const BehanceLink = styled.div`
  ${linkShared};
  left: ${parseUIPercents(272)};
  @media (max-width: 768px) {
    left: ${parseUIPercentsMobile(151)};
  }
`
export const MediumLink = styled.div`
  ${linkShared};
  left: ${parseUIPercents(304)};
  @media (max-width: 768px) {
    left: ${parseUIPercentsMobile(195)};
  }
`
export const LinkedLink = styled.div`
  ${linkShared};
  left: ${parseUIPercents(336)};
  @media (max-width: 768px) {
    left: ${parseUIPercentsMobile(239)};
  }
`
export const InstagramLink = styled.div`
  ${linkShared};
  left: ${parseUIPercents(368)};
  @media (max-width: 768px) {
    left: ${parseUIPercentsMobile(283)};
  }
`
